/* =============================================================
   Brummbacher · site.js
   Cart state · language toggle · forms · drawer · toasts
   This is the JS that mirrors what the Shopify theme would do
   client-side. The .liquid templates use Shopify's native cart.js
   instead — the structure is the same.
   ============================================================= */

(function () {
  // ---------- language ----------
  const STORAGE_LANG = 'bb-lang';
  function setLang(lang) {
    document.documentElement.setAttribute('data-lang', lang);
    document.documentElement.setAttribute('lang', lang === 'en' ? 'en' : 'de-CH');
    localStorage.setItem(STORAGE_LANG, lang);
    document.querySelectorAll('[data-lang-btn]').forEach(b => {
      b.classList.toggle('is-active', b.dataset.langBtn === lang);
    });
  }
  function initLang() {
    const saved = localStorage.getItem(STORAGE_LANG) || 'de';
    setLang(saved);
    document.querySelectorAll('[data-lang-btn]').forEach(b => {
      b.addEventListener('click', () => setLang(b.dataset.langBtn));
    });
  }

  // ---------- cart ----------
  const STORAGE_CART = 'bb-cart';
  let cart = [];
  try { cart = JSON.parse(localStorage.getItem(STORAGE_CART) || '[]'); } catch { cart = []; }

  function saveCart() {
    localStorage.setItem(STORAGE_CART, JSON.stringify(cart));
    renderCart();
  }
  function addToCart(item) {
    const existing = cart.find(c => c.id === item.id);
    if (existing) { existing.qty += item.qty || 1; }
    else { cart.push({ ...item, qty: item.qty || 1 }); }
    saveCart();
    showToast(item.name + ' · in den Warenkorb');
  }
  function changeQty(id, delta) {
    const it = cart.find(c => c.id === id); if (!it) return;
    it.qty = Math.max(0, it.qty + delta);
    if (it.qty === 0) cart = cart.filter(c => c.id !== id);
    saveCart();
  }
  function renderCart() {
    const count = cart.reduce((s, i) => s + i.qty, 0);
    const total = cart.reduce((s, i) => s + i.qty * i.price, 0);
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'inline-flex' : 'none';
    });
    const list = document.querySelector('[data-cart-list]');
    const totalEl = document.querySelector('[data-cart-total]');
    const empty = document.querySelector('[data-cart-empty]');
    const foot = document.querySelector('[data-cart-foot]');
    if (!list) return;
    if (count === 0) {
      list.innerHTML = '';
      if (empty) empty.style.display = 'block';
      if (foot) foot.style.display = 'none';
      return;
    }
    if (empty) empty.style.display = 'none';
    if (foot) foot.style.display = 'block';
    list.innerHTML = cart.map(it => `
      <div class="cart-item">
        <div class="cart-item__photo"><img src="${it.img}" alt=""></div>
        <div>
          <div class="cart-item__name">${it.name}</div>
          <div class="cart-item__variant">${it.variant || ''}</div>
          <div class="cart-item__qty">
            <button type="button" data-qty-down="${it.id}" aria-label="weniger">−</button>
            <span>${it.qty}</span>
            <button type="button" data-qty-up="${it.id}" aria-label="mehr">+</button>
          </div>
        </div>
        <div class="cart-item__price">CHF ${(it.qty * it.price).toFixed(2)}</div>
      </div>
    `).join('');
    if (totalEl) totalEl.textContent = 'CHF ' + total.toFixed(2);
    list.querySelectorAll('[data-qty-up]').forEach(b => b.addEventListener('click', () => changeQty(b.dataset.qtyUp, +1)));
    list.querySelectorAll('[data-qty-down]').forEach(b => b.addEventListener('click', () => changeQty(b.dataset.qtyDown, -1)));
  }

  function openCart() {
    document.querySelector('[data-cart-drawer]')?.classList.add('is-open');
    document.querySelector('[data-cart-overlay]')?.classList.add('is-open');
  }
  function closeCart() {
    document.querySelector('[data-cart-drawer]')?.classList.remove('is-open');
    document.querySelector('[data-cart-overlay]')?.classList.remove('is-open');
  }

  // ---------- toast ----------
  let toastTimer;
  function showToast(msg) {
    let el = document.querySelector('.toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'toast';
      document.body.appendChild(el);
    }
    el.textContent = msg;
    requestAnimationFrame(() => el.classList.add('is-show'));
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-show'), 2200);
  }

  // ---------- form validation ----------
  function initForms() {
    document.querySelectorAll('form[data-form]').forEach(form => {
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        let ok = true;
        form.querySelectorAll('[required]').forEach(f => {
          const field = f.closest('.form__field') || f;
          if (!f.value || (f.type === 'email' && !/^\S+@\S+\.\S+$/.test(f.value))) {
            field.classList.add('has-error');
            ok = false;
          } else {
            field.classList.remove('has-error');
          }
        });
        if (ok) form.classList.add('is-success');
      });
      form.querySelectorAll('input, select, textarea').forEach(f => {
        f.addEventListener('input', () => f.closest('.form__field')?.classList.remove('has-error'));
        f.addEventListener('change', () => f.closest('.form__field')?.classList.remove('has-error'));
      });
    });
  }

  // ---------- form-type tabs (Kontakt) ----------
  function initFormTabs() {
    document.querySelectorAll('[data-form-tabs]').forEach(tabs => {
      tabs.querySelectorAll('button').forEach(b => {
        b.addEventListener('click', () => {
          tabs.querySelectorAll('button').forEach(x => x.classList.remove('is-active'));
          b.classList.add('is-active');
          const target = b.dataset.target;
          document.querySelectorAll('[data-form-panel]').forEach(p => {
            p.style.display = p.dataset.formPanel === target ? '' : 'none';
          });
        });
      });
    });
  }

  // ---------- shop category tabs ----------
  function initShopTabs() {
    document.querySelectorAll('[data-shop-tabs]').forEach(tabs => {
      function applyFilter(cat) {
        document.querySelectorAll('[data-product]').forEach(p => {
          p.style.display = (cat === 'all' || p.dataset.product.split(' ').includes(cat)) ? '' : 'none';
        });
      }
      tabs.querySelectorAll('button').forEach(b => {
        b.addEventListener('click', () => {
          tabs.querySelectorAll('button').forEach(x => x.classList.remove('is-active'));
          b.classList.add('is-active');
          applyFilter(b.dataset.category);
        });
      });
      // apply the initially active tab's filter on load
      const active = tabs.querySelector('button.is-active') || tabs.querySelector('button');
      if (active) {
        active.classList.add('is-active');
        applyFilter(active.dataset.category);
      }
    });
  }

  // ---------- add-to-cart wiring ----------
  function initAddButtons() {
    document.body.addEventListener('click', (e) => {
      const b = e.target.closest('[data-add-to-cart]');
      if (!b) return;
      const item = {
        id: b.dataset.id,
        name: b.dataset.name,
        variant: b.dataset.variant,
        img: b.dataset.img,
        price: parseFloat(b.dataset.price),
        qty: parseInt(b.dataset.qty || '1', 10)
      };
      addToCart(item);
      b.classList.add('is-added');
      const orig = b.textContent;
      b.textContent = '✓ Hinzugefügt';
      setTimeout(() => { b.classList.remove('is-added'); b.textContent = orig; }, 1400);
    });
  }

  function initCartUi() {
    document.querySelectorAll('[data-cart-open]').forEach(b => b.addEventListener('click', openCart));
    document.querySelectorAll('[data-cart-close]').forEach(b => b.addEventListener('click', closeCart));
    document.querySelector('[data-cart-overlay]')?.addEventListener('click', closeCart);
  }

  // ---------- lightbox ----------
  function initLightbox() {
    const imgs = document.querySelectorAll('.cta-custom__gallery img');
    if (!imgs.length) return;

    let box = document.querySelector('.bb-lightbox');
    if (!box) {
      box = document.createElement('div');
      box.className = 'bb-lightbox';
      box.innerHTML = '<button type="button" class="bb-lightbox__close" aria-label="Schliessen">&times;</button><img alt="">';
      document.body.appendChild(box);
    }
    const boxImg = box.querySelector('img');
    function close() { box.classList.remove('is-open'); }

    imgs.forEach(img => {
      img.addEventListener('click', () => {
        boxImg.src = img.currentSrc || img.src;
        boxImg.alt = img.alt || '';
        box.classList.add('is-open');
      });
    });
    box.addEventListener('click', close);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
  }

  // ---------- mobile nav ----------
  function initMobileNav() {
    const btn = document.querySelector('[data-nav-toggle]');
    const nav = document.querySelector('[data-mobile-nav]');
    if (!btn || !nav) return;
    btn.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      btn.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.setAttribute('aria-label', open ? 'Menü schliessen' : 'Menü öffnen');
    });
  }

  // ---------- age gate ----------
  function initAgeGate() {
    const gate = document.querySelector('[data-age-gate]');
    if (!gate) return;
    let ok = false;
    try { ok = localStorage.getItem('bb-age-ok') === '1'; } catch (e) {}
    if (ok) { gate.classList.add('is-hidden'); return; }

    document.body.style.overflow = 'hidden';
    const confirm = gate.querySelector('[data-age-confirm]');
    const deny = gate.querySelector('[data-age-deny]');
    const denyMsg = gate.querySelector('[data-age-deny-msg]');
    const actions = gate.querySelector('.age-gate__actions');

    if (confirm) confirm.addEventListener('click', () => {
      try { localStorage.setItem('bb-age-ok', '1'); } catch (e) {}
      gate.classList.add('is-hidden');
      document.body.style.overflow = '';
    });
    if (deny) deny.addEventListener('click', () => {
      if (denyMsg) denyMsg.removeAttribute('hidden');
      if (actions) actions.style.display = 'none';
    });
  }

  // ---------- footer legal menu ----------
  function initLegalMenu() {
    const btn = document.querySelector('[data-legal-toggle]');
    const menu = document.querySelector('[data-legal-menu]');
    if (!btn || !menu) return;
    btn.addEventListener('click', () => {
      const open = menu.hasAttribute('hidden');
      if (open) { menu.removeAttribute('hidden'); }
      else { menu.setAttribute('hidden', ''); }
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // ---------- product size picker ----------
  function initSizePicker() {
    const form = document.querySelector('[data-size-form]');
    if (!form) return;
    const radios = form.querySelectorAll('.size-pill input[type="radio"]');
    if (!radios.length) return;
    const priceEl = document.querySelector('[data-price-target]');
    const stockEl = document.querySelector('[data-stock-target]');
    const addBtn = form.querySelector('[data-add-btn]');

    function sync() {
      radios.forEach(r => r.closest('.size-pill').classList.toggle('is-selected', r.checked));
      const sel = form.querySelector('.size-pill input:checked');
      if (!sel) return;
      const available = sel.dataset.available === 'true';
      const inv = parseInt(sel.dataset.inventory, 10) || 0;
      if (priceEl) priceEl.textContent = sel.dataset.price;
      if (stockEl) stockEl.textContent = available && inv > 0 ? inv + ' an Lager' : 'Ausverkauft';
      if (addBtn) {
        addBtn.disabled = !available;
        addBtn.textContent = available ? 'In den Warenkorb · ' + sel.dataset.price : 'Ausverkauft';
      }
    }
    radios.forEach(r => r.addEventListener('change', sync));
    sync();
  }

  // ---------- init ----------
  document.addEventListener('DOMContentLoaded', () => {
    initLang();
    initForms();
    initFormTabs();
    initShopTabs();
    initAddButtons();
    initCartUi();
    initMobileNav();
    initLegalMenu();
    initAgeGate();
    initLightbox();
    initSizePicker();
    renderCart();
  });

  // expose for inline scripts
  window.BB = { addToCart, openCart, closeCart };
})();
